export default __webpack_public_path__ + "static/media/statictv.6467fb88.svg";